// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 公证订单状态异步通知 法谡在订单状态变更时 POST 至发起公证时配置的 notifyUrl；受理成功须返回纯文本 success（见 api_6）。 POST /api/v1/notary/notify */
export async function NotaryControllerNotifyV1(
  body: MyApi.NotaryNotifyDto,
  options?: { [key: string]: any }
) {
  return request<any>("/api/v1/notary/notify", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
